import getSymbolFromCurrency from 'currency-symbol-map';
import { BookingFee } from 'widget/event_components/Ticket/components/BookingFee';
import { PayWhatYouWantInput } from 'widget/event_components/Ticket/components/PayWhatYouWant';

export const PaymentPriceWrapper = ({ errors, ticket, event, settings, handleTicketOverride }) => {
  if (settings.get('hideFreePriceLabel')) return null;
  if (ticket.get('pay_what_you_want')) {
    return <PayWhatYouWantInput errors={errors} settings={settings} ticket={ticket} event={event} handleTicketOverride={handleTicketOverride} />;
  }
  const priceNum = Math.max(0, +ticket.get('price'));
  return (
    <div style={{ textAlign: 'right', gap: 12, display: 'flex' }}>
      {getSymbolFromCurrency(event.get('currency'))}
      {priceNum.toFixed(2)}
      {ticket.get('enable_booking_fee') && <BookingFee ticket={ticket} currency={getSymbolFromCurrency(event.get('currency'))} />}
    </div>
  );
};
